import React, { useState, useEffect } from "react";
import { Card, Table, Statistic } from "antd";
import { useParams } from "react-router-dom";
import { orderStatus } from "utility/options/index";

import { apiGetTicketStatistic, apiGetStatistic } from "api";

const Tickets = () => {
  const { id } = useParams();
  const [rowData, setRowData] = useState({});
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  const fetchRowData = async () => {
    setIsLoading(true);
    try {
      const res = await apiGetStatistic({ id });
      const { content } = res.data;
      setRowData(content);
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTableData = async () => {
    try {
      const res = await apiGetTicketStatistic({
        id,
        offset: current * pageSize - pageSize,
        limit: pageSize,
      });
      const { content, paging } = res.data;
      setTableData(content);
      setTotal(paging.count);
    } catch (error) {
      console.log("error", error);
    }
  };

  // # 切換頁籤
  const onTableChange = (pagination) => {
    setCurrent(pagination.current);
  };

  const onShowSizeChange = (current, pageSize) => {
    console.log(current, pageSize);
    setPageSize(pageSize);
  };

  useEffect(() => {
    fetchRowData();
    fetchTableData();
  }, []);

  useEffect(() => {
    fetchTableData();
  }, [current, pageSize]);

  const columns = [
    {
      title: "票券名稱",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "狀態",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let result = orderStatus.find((item) => item.value == text);
        return <p>{result?.label}</p>;
      },
    },
    {
      title: "總數",
      dataIndex: "originalQuantity",
      key: "originalQuantity",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "剩餘",
      dataIndex: "remainQuantity",
      key: "remainQuantity",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "付款成功",
      dataIndex: "orderQuantity",
      key: "orderQuantity",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "報到成功",
      dataIndex: "shipQuantity",
      key: "shipQuantity",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "公關票",
      dataIndex: "prQuantity",
      key: "prQuantity",
      render: (text) => <p>{text}</p>,
    },
    {
      title: "售價",
      dataIndex: "price",
      key: "price",
      render: (text) => <p>＄{text}</p>,
    },
    {
      title: "手續費",
      dataIndex: "fee",
      key: "fee",
      render: (text) => <p>＄{text}</p>,
    },
    {
      title: "小計",
      dataIndex: "profit",
      key: "profit",
      render: (text) => <p>＄{text}</p>,
    },
  ];

  const statisticCards = [
    {
      title: "剩餘總張數",
      value: rowData.remainQuantity,
    },
    {
      title: "報名成功",
      value: rowData.orderQuantity,
    },
    {
      title: "票券收入",
      value: rowData.profit,
      prefix: "NT$",
    },
    {
      title: "手續費",
      value: rowData.fee,
      prefix: "NT$",
    },
    {
      title: "淨利",
      value: (rowData.profit || 0) - (rowData.fee || 0),
      prefix: "NT$",
    },
  ];

  return (
    <Card
      title={<h3 className="text-left">售票資訊</h3>}
      className="text-center mt-5 rounded-3xl px-0 min-h-[calc(100vh-250px)]"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {statisticCards.map((item) => (
          <Card
            key={item.title}
            className="bg-Gray-1 font-bold h-full [&_.ant-card-body]:flex [&_.ant-card-body]:items-center [&_.ant-card-body]:justify-center"
          >
            <Statistic
              title={item.title}
              className="text-Gray-5 [&_.ant-statistic-title]:text-base [&_.ant-statistic-title]:font-bold [&_.ant-statistic-content]:whitespace-nowrap"
              value={item.value}
              prefix={item.prefix}
            />
          </Card>
        ))}
      </div>
      <Table
        columns={columns}
        loading={isLoading}
        dataSource={tableData}
        className="mt-5"
        onChange={onTableChange}
        pagination={{
          total,
          current,
          pageSize,
          showSizeChanger: true,
          onShowSizeChange,
        }}
        scroll={{ x: "max-content" }}
      ></Table>
    </Card>
  );
};

export default Tickets;
